import { render, staticRenderFns } from "./orderSurvey.vue?vue&type=template&id=496a0328&"
import script from "./orderSurvey.vue?vue&type=script&lang=js&"
export * from "./orderSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports